/**
 * Path3D registration: the parser. Path3D draws a Curve3D polyline gizmo for every node
 * (ADR-0056) and provides the curve to PathFollow3D children.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parsePath3D } from './parser';
const path3DRegistration = {
    typeName: 'Path3D',
    parser: parsePath3D,
};
nodeRegistry.register(path3DRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map